// src/components/Footer.js
import React from 'react';
import { Box, Typography, IconButton, Container, Grid } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#1c0a49',
        color: '#d75efb',
        py: 4,
        mt: 8,
        textAlign: 'center',
        position: 'relative',
        bottom: 0,
        width: '100%',
      }}
    >
      <Container>
        <Grid container spacing={4} justifyContent="center">
          <Grid item>
            <Typography variant="h6" gutterBottom>
              Find Us On
            </Typography>
            <IconButton
              component="a"
              href="https://www.instagram.com/_whimssicalstitches/?igsh=bDhnZWZqNmZxeWJ1"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.facebook.com/profile.php?id=61568872957012"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://wa.me/254114075312"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
            <WhatsAppIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Typography variant="body2" sx={{ mt: 2 }}>
          &copy; {new Date().getFullYear()} Whimssical Stitches. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
